import axios from 'axios'
import IAvailableProduct from '@interfaces/IAvailableProduct'

export const available = (): Promise<any> => axios.get('/products/available')

export const updateAvailable = (availableProducts: IAvailableProduct[]): Promise<any> => axios.put('/products/available', availableProducts)
